export default __webpack_public_path__ + "static/media/05_o_preview_3.145032b3.jpg";